const escapeText = (text) => new Handlebars.SafeString(Handlebars.Utils.escapeExpression(text));
export default escapeText;
